export default __webpack_public_path__ + "static/media/delegate.31359ce3.svg";